<template>
  <b-modal
    ref="modal"
    :title="$t('influencer_panel.pix_register')"
    :ok-title="$t('save')"
    :cancel-title="$t('action.cancel')"
    cancel-variant="outline-secondary"
    :ok-disabled="!canSubmit"
    centered
    @ok.prevent="submit"
    @hidden="reset"
  >
    <b-form-group :label="$t('influencer_panel.pix_type')">
      <b-form-select v-model="keyType" :options="typeOptions" />
    </b-form-group>

    <b-form-group :label="$t('influencer_panel.pix_key')">
      <b-form-input v-model="keyValue" type="text" :placeholder="placeholder" />
    </b-form-group>

    <p class="pix-form__note">
      <feather-icon icon="InfoIcon" size="14" />
      {{ $t('influencer_panel.pix_hint') }}
    </p>
  </b-modal>
</template>

<script>
import {
  BModal, BFormGroup, BFormInput, BFormSelect,
} from 'bootstrap-vue'

/** Cadastro de chave PIX. Os tipos e rotulos sao os do backend. */
const TYPES = [
  { value: 'CP', text: 'CPF', placeholder: '000.000.000-00' },
  { value: 'CN', text: 'CNPJ', placeholder: '00.000.000/0000-00' },
  { value: 'EM', text: 'E-mail', placeholder: 'voce@email.com' },
  { value: 'TE', text: 'Telefone', placeholder: '(11) 90000-0000' },
  { value: 'AL', text: 'Aleatória', placeholder: '00000000-0000-0000-0000-000000000000' },
]

export default {
  name: 'PixKeyFormModal',
  components: {
    BModal, BFormGroup, BFormInput, BFormSelect,
  },
  data: () => ({ keyType: 'CP', keyValue: '' }),
  computed: {
    typeOptions() {
      return TYPES.map(({ value, text }) => ({ value, text }))
    },
    placeholder() {
      return (TYPES.find(t => t.value === this.keyType) || {}).placeholder || ''
    },
    canSubmit() {
      return !!this.keyType && this.keyValue.trim().length > 0
    },
  },
  methods: {
    open() {
      this.$refs.modal.show()
    },
    close() {
      this.$refs.modal.hide()
    },
    reset() {
      this.keyType = 'CP'
      this.keyValue = ''
    },
    submit() {
      this.$emit('save', { keyType: this.keyType, keyValue: this.keyValue.trim() })
    },
  },
}
</script>

<style scoped>
.pix-form__note {
  margin: 0;
  display: flex;
  align-items: flex-start;
  gap: 0.45rem;
  font-size: var(--fs-sm);
  color: var(--text-muted);
}
</style>
